<template>
  <div class="about-us_wrap">
    <div class="cont_container">
      <div class="img_box">
        <img :src="imgUrl" alt="" class="img">
      </div>
      <div class="text_box">
        <p class="title">{{ title }}</p>
        <p class="text">{{ content }}</p>
        <div class="btn" @click="goToIntro">查看更多</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        title: "公司简介",
        content: "福建平潭瑞谦智能科技有限公司是一家专业从事人工智能软件开发的高新技术企业，致力于为学校、企业、政务客户提供集软件开发、系统集成、IT运维等一体的信息化综合解决方案。公司拥有自主知识产权的深度学习核心算法技术、神经网络计算引擎技术，为客户提供国内外领先的人工智能物联网智慧终端和数据平台。",
        pathUrl: "/",
        imgUrl: require('@/assets/img/home/aboutUs/us.jpg')
      }
    },
    methods: {
      goToIntro() {
        this.$router.push('/about/intro')
      }
    }
  }
</script>

<style scoped lang="scss">
.about-us_wrap {
  width: 100%;
  height: 100%;
  min-height: 300px;
  margin-top: 0;
  padding-top: 100px;
  padding-bottom: 100px;
  background-image: url("../../../assets/img/home/aboutUs/bg.png");
  @media screen and (max-width: 768px) {
    padding-top: 30px;
    padding-bottom: 60px;
    background-repeat: no-repeat;
    background-position: bottom center;
  }
}
.cont_container {
  display: flex;
  width: auto;
  max-width: 1280px;
  min-width: 0;
  height: auto;
  min-height: 0;
  margin: 0 auto;
  padding: 0;
  background-color: rgb(255, 255, 255);
  @media screen and (max-width: 768px) {
    flex-direction: column;
    background-color: rgb(255, 255, 255, 0);
  }
  .img_box {
    display: flex;
    flex: 0 0 44%;
    background-color: rgb(255, 255, 255);
    overflow: hidden;
    .img {
      width: 100%;
      object-fit: contain;
    }
  }
  .text_box {
    align-self: center;
    padding: 0 60px;
    .title {
      width: auto;
      max-width: none;
      min-width: 0;
      height: auto;
      max-height: none;
      min-height: 0;
      padding: 0;
      top: auto;
      bottom: auto;
      left: auto;
      right: auto;
      z-index: auto;
      margin: 0 auto;
      font-size: 30px;
      color: rgba(5, 85, 182, 1);
      line-height: 1;
    }
    .text {
      width: auto;
      max-width: 520px;
      min-width: 0;
      height: auto;
      max-height: none;
      min-height: 0;
      padding: 0;
      top: auto;
      bottom: auto;
      left: auto;
      right: auto;
      z-index: auto;
      margin: 20px auto 0 0;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
      line-height: 1.8;
    }
    .btn {
      width: auto;
      height: auto;
      text-align: center;
      max-width: 120px;
      min-width: 120px;
      max-height: none;
      min-height: 0;
      margin: 40px 0 0;
      padding: 6px 12px;
      border-radius: 5px;
      border: 1px solid #dddddd;
      color: rgba(85, 85, 85, 1);
      font-size: 14px;
      &:hover {
        color: rgba(255, 255, 255, 1);
        background-color: rgb(5, 85, 182);
        cursor: pointer;
      }
    }
  }
}
</style>
